// services/authService.js
import axios from 'axios';

//const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const API_BASE_URL = 'https://resolvebo.innovationcode.pro/api';


const authService = {
    /**
     * Envoie une demande de code OTP à l'adresse email spécifiée
     * @param {string} email - L'adresse email de l'utilisateur
     * @returns {Promise} - Une promesse contenant la réponse de l'API
     */
    sendOTP: async (email) => {
        try {
            const response = await axios.post(`${API_BASE_URL}/auth/send-otp`, { email });
            return response.data;
        } catch (error) {
            console.error('Erreur lors de l\'envoi du code OTP:', error);

            if (error.response) {
                throw new Error(error.response.data.message || 'Erreur lors de l\'envoi du code OTP');
            } else if (error.request) {
                throw new Error('Serveur injoignable. Veuillez réessayer plus tard.');
            } else {
                throw new Error('Erreur lors de la préparation de la requête');
            }
        }
    },

    /**
     * Vérifie le code OTP fourni pour l'adresse email spécifiée
     * @param {string} email - L'adresse email de l'utilisateur
     * @param {string} otpCode - Le code OTP à vérifier
     * @returns {Promise} - Une promesse contenant la réponse de l'API
     */
    verifyOTP: async (email, otpCode) => {
        try {
            const response = await axios.post(`${API_BASE_URL}/auth/verify-otp`, {
                email,
                otpCode
            });

            // Si la vérification est réussie, stocker l'email vérifié
            if (response.data.success) {
                sessionStorage.setItem('verifiedEmail', email);
            }

            return response.data;
        } catch (error) {
            console.error('Erreur lors de la vérification du code OTP:', error);

            if (error.response) {
                throw new Error(error.response.data.message || 'Code de vérification invalide');
            } else if (error.request) {
                throw new Error('Serveur injoignable. Veuillez réessayer plus tard.');
            } else {
                throw new Error('Erreur lors de la préparation de la requête');
            }
        }
    },

    /**
     * Vérifie si l'email de l'utilisateur est vérifié
     * @returns {boolean} - true si l'email est vérifié, false sinon
     */
    isEmailVerified: () => {
        return !!sessionStorage.getItem('verifiedEmail');
    },

    /**
     * Récupère l'email vérifié
     * @returns {string|null} - L'email vérifié ou null si aucun
     */
    getVerifiedEmail: () => {
        return sessionStorage.getItem('verifiedEmail');
    },

    /**
     * Efface les informations de vérification d'email
     */
    clearVerification: () => {
        sessionStorage.removeItem('verifiedEmail');
    }
};

export { authService };